















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Track } from '@/data';

@Component
export default class NowPlaying extends Vue {
  @Prop({default: null}) private track!: Track | null;
  @Prop({default: ''}) private roomID!: string;

  private errMsg = '';

  get artist(): string {
    if (!this.track) {
      return '';
    }
    const names = [];
    for (const artist of this.track.artists) {
      names.push(artist.name);
    }
    return names.join(', ');
  }

  get image(): string {
    const defURL = 'https://via.placeholder.com/150x150';
    if (!this.track) {
      return defURL;
    }
    if (!this.track.album) {
      return defURL;
    }
    if (this.track.album.images.length > 0) {
      return this.track.album.images[0].url;
    }
    return defURL;
  }

  private clearErr(): void {
    this.errMsg = '';
  }
}
